<template>
  <div class="retail-shell">
    <!-- 复用会员插件零售收银台（040103），独立窗口全屏承载 -->
    <cashier-desk />
  </div>
</template>

<script>
import CashierDesk from '@/views/plugin/member/cashier/CashierDesk.vue'

/**
 * 零售收银独立壳（/cashier/retail）：仅全屏承载 member 插件 CashierDesk。
 * CashierDesk 依赖的 store（userInfo getter 读 Vue.ls）、API 均为全局，自包含无需额外适配。
 */
export default {
  name: 'DiningCashierRetailShell',
  components: { CashierDesk }
}
</script>

<style scoped>
.retail-shell {
  height: 100vh;
  overflow: hidden;
  background: #f5f5f5;
}
/* 独立窗口无 TabLayout 头部：覆写 CashierDesk 的 calc(100vh-130px) 为整屏（子根元素可命中父 scoped 样式） */
.retail-shell .cashier-desk {
  height: 100vh;
}
</style>
